import React from "react";
import {
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from "@mui/material";
import Libelle from "../../_i18n/fr.json";

interface Props {
  page: number;
  nbrElementTotal: number;
  nbrElementParPage: number;
  nbrElementParPageOptions?: number[];
  onChangerPage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onChangerNbrResultatParPage: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    nbrElement: number
  ) => void;
  colSpan: number;
}

const Pagination: React.FC<Props> = ({
  page,
  nbrElementTotal,
  nbrElementParPage,
  nbrElementParPageOptions = [5, 10, 20],
  onChangerPage,
  onChangerNbrResultatParPage,
  colSpan,
}) => {
  const resultatAffiche = () => {
    const from = nbrElementTotal === 0 ? 0 : page * nbrElementParPage + 1;
    const to = Math.min(nbrElementTotal, (page + 1) * nbrElementParPage);
    return `${from}-${to} sur ${nbrElementTotal}`;
  };

  return (
    <TableFooter className="footer">
      <TableRow>
        <TableCell>
          {nbrElementTotal > 0
            ? Libelle.tableau.resultat.replace(
                "{count}",
                nbrElementTotal.toString()
              )
            : Libelle.tableau.aucun}
        </TableCell>
        <TablePagination
          colSpan={colSpan}
          count={nbrElementTotal}
          rowsPerPage={nbrElementParPage}
          rowsPerPageOptions={nbrElementParPageOptions}
          labelDisplayedRows={() => resultatAffiche()}
          labelRowsPerPage={Libelle.tableau.pagination.resultat}
          page={page}
          onPageChange={onChangerPage}
          onRowsPerPageChange={(event) =>
            onChangerNbrResultatParPage(event, parseInt(event.target.value, 10))
          }
        />
      </TableRow>
    </TableFooter>
  );
};

export default Pagination;
